import TableLoading from "../common/Loading/table_loading";
import {
  emptyValue,
  formatBatteryLevel,
  formatBooleanState,
  formatTimestamp,
  getDeviceName,
  getRentalName,
} from "./utils";

const DeviceHealthTable = ({ devices = [], loading = false }) => {
  if (loading) {
    return <table className="uk-table uk-table-hover uk-table-divider hms-table"><tbody>{TableLoading(8)}</tbody></table>;
  }

  return (
    <table className="uk-table uk-table-hover uk-table-divider hms-table seam-device-table">
      <thead>
        <tr>
          <th>DEVICE</th>
          <th>PROPERTY</th>
          <th>ONLINE</th>
          <th>LOCK</th>
          <th>BATTERY</th>
          <th>LOW BATTERY</th>
          <th>LAST SEEN</th>
          <th>LAST EVENT</th>
        </tr>
      </thead>
      <tbody>
        {devices.length ? (
          devices.map((device, index) => {
            const online = formatBooleanState(device.is_online, "Online", "Offline");
            const lock = formatBooleanState(device.is_locked, "Locked", "Unlocked");
            const lowBattery = formatBooleanState(device.is_low_battery, "Yes", "No");

            return (
              <tr key={device.device_id || index}>
                <td>
                  <div className="seam-device-name">{getDeviceName(device)}</div>
                  <div className="seam-device-subtitle">
                    {[device.manufacturer, device.model].filter(Boolean).join(" ") || device.device_id || emptyValue}
                  </div>
                </td>
                <td>{getRentalName(device)}</td>
                <td>
                  <span className={`seam-status-pill ${device.is_online === false ? "seam-status-danger" : device.is_online === true ? "seam-status-success" : "seam-status-neutral"}`}>
                    {online}
                  </span>
                </td>
                <td>{lock}</td>
                <td>
                  <div>{formatBatteryLevel(device.battery_level)}</div>
                  <div className="seam-device-subtitle">{device.battery_status || emptyValue}</div>
                </td>
                <td>
                  <span className={`seam-status-pill ${device.is_low_battery ? "seam-status-warning" : "seam-status-neutral"}`}>
                    {lowBattery}
                  </span>
                </td>
                <td>{formatTimestamp(device.last_seen_at)}</td>
                <td>{formatTimestamp(device.last_event_at || device.updated_at)}</td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={8} className="no-records">
              No smart lock devices found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default DeviceHealthTable;
